import React from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { CircularProgress, Button } from "@mui/material";
import * as Styled from "./styles";
import { getRandomId } from "../../../../utils/helpers";

const MediaMasonry = ({
  content = [],
  isLoading = false,
  handleErrorImage = () => {},
  onReplaceButtonPress = () => {},
  buttonText = "Replace",
  type,
  loadingImageItems = new Set(),
}) => {
  return (
    <>
      {isLoading && content?.length === 0 ? (
        <Styled.LoaderContainer>
          <CircularProgress size={24} />
        </Styled.LoaderContainer>
      ) : (
        <>
          <ResponsiveMasonry
            columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}
          >
            <Masonry>
              {content?.length &&
                content.map((image, i) => {
                  const isItemLoading = loadingImageItems.has(image);

                  return (
                    <Styled.ImageContainer key={i}>
                      <img
                        src={image}
                        style={Styled.imageStyle}
                        alt={`${image}+${i}`}
                        onError={() => {
                          handleErrorImage(image);
                        }}
                      />
                      <Styled.Overlay>
                        <Button
                          variant="contained"
                          disabled={isItemLoading}
                          sx={{
                            mb: "10px",
                            backgroundColor: "#FFFFFF",
                            fontFamily: "DM Sans",
                            fontWeight: "400",
                            fontSize: "12px",
                            color: "#123051",
                            height: "24px",
                            lineHeight: "20px",
                            textTransform: "none",
                            borderWidth: 1,
                            borderColor: "red",
                            width: "80%",
                            minWidth: "60px",
                          }}
                          onClick={() => {
                            onReplaceButtonPress({
                              id: getRandomId(),
                              src: image,
                              title: "",
                            });
                          }}
                        >
                          {isItemLoading ? (
                            <CircularProgress
                              size={16}
                              sx={{ color: "purple" }}
                            />
                          ) : (
                            buttonText
                          )}
                        </Button>
                      </Styled.Overlay>
                    </Styled.ImageContainer>
                  );
                })}
            </Masonry>
          </ResponsiveMasonry>
          {isLoading && (
            <Styled.ProgressContainer>
              <CircularProgress size={24} />
            </Styled.ProgressContainer>
          )}
        </>
      )}
    </>
  );
};

export default MediaMasonry;
